// extracted by mini-css-extract-plugin
export var modal = "_ct-0";